module.exports = __webpack_public_path__ + "img/iconGoogle.bfd6437f.svg";